<script>
import ComparisonMobile from './mobile/index.vue';
import ComparisonDesktop from './desktop.vue';
import { largeMeetingDisabledConfig, ZoomOneEduComparison } from '../../datas/zoomone-edu-comparison';
import { isMobile } from '@zoom/billing-responsive';

export default {
  name: 'ComparisonTable',
  data() {
    return { treeData: [] };
  },
  props: {
    appName: {
      type: String,
      default: 'pricing'
    },
    largeMeetingConfig: {
      type: Object,
      default: ()=> {
        return largeMeetingDisabledConfig
      }
    },
    enableDocsFeature: {
      type: Boolean,
      default: false
    },
    showDocsLearnMore: {
      type: Boolean,
      default: false
    },
    DocsCallBack : {
      type: Function,
      default () {
        return () => {}
      }
    },
    enableDisplayZoomTasksWithoutAccountCheck: {
      type: Boolean,
      default: false,
    },
    enableDisplayZoomWorkFlow: {
      type: Boolean,
      default: false,
    },
    enableDisplayZoomDrive: {
      type: Boolean,
      default: false,
    },
    showTasksLearnMore: {
      type: Boolean,
      default: false
    },
    eventTracking: {
      type: Object,
    },
    showCampusScheduler: {
      type: Boolean,
      default: false
    },
    isEligibleAccount4CustomAvatarFeature: {
      type: Boolean,
      default: false,
    },
    showCustomAvatar: {
      type: Boolean,
      default: false,
    },
    enableEduWorkspaceReservations: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    const largeMeetingConfig = this.largeMeetingConfig;
    const enableDocsFeature = this.enableDocsFeature;
    const showDocsLearnMore = this.showDocsLearnMore;
    const DocsCallBack = this.DocsCallBack;

    const enableDisplayZoomTasksWithoutAccountCheck = this.enableDisplayZoomTasksWithoutAccountCheck;
    const showTasksLearnMore = this.showTasksLearnMore;
    const tasksEventTracking = this.eventTracking?.tasks
    const aiCompanionEventTracking = this.eventTracking?.aiCompanion
    const appName = this.appName
    const showCampusScheduler = this.showCampusScheduler;
    const isEligibleAccount4CustomAvatarFeature = this.isEligibleAccount4CustomAvatarFeature;
    const showCustomAvatar = this.showCustomAvatar;
    const customAvatarEventTracking = this.eventTracking?.custom_avatar
    const enableDisplayZoomWorkFlow = this.enableDisplayZoomWorkFlow
    const enableDisplayZoomDrive = this.enableDisplayZoomDrive
    const enableEduWorkspaceReservations = this.enableEduWorkspaceReservations
    this.treeData = new ZoomOneEduComparison({ largeMeetingConfig, enableDocsFeature, showDocsLearnMore, DocsCallBack, enableDisplayZoomTasksWithoutAccountCheck, showTasksLearnMore, tasksEventTracking, aiCompanionEventTracking, appName, showCampusScheduler, enableDisplayZoomWorkFlow, enableDisplayZoomDrive, isEligibleAccount4CustomAvatarFeature, customAvatarEventTracking, showCustomAvatar, enableEduWorkspaceReservations }).build().resultGetter
  },
  render() {
    const context = {
      props: { ...this.$attrs, ...this.$props, treeData: this.treeData },
      on: { ...this.$listeners },
      scopedSlots: this.$scopedSlots,
    };
    return isMobile ? (
      <ComparisonMobile {...context} />
    ) : (
      <ComparisonDesktop {...context} />
    )
  }
};
</script>
